import {
  AdminUsersResponseType,
  ApiClient,
  ApiErrorMessage,
  CategoryResponseType,
  MailingListResponseType,
  PhrasesResponseType,
  SettingsResponseType,
  TrainGroupsResponseType,
  TrainsResponseType
} from './ApiClient';

export const UpdateAdminUsersApi = async (
  id: number,
  body: object
): Promise<AdminUsersResponseType> => {
  try {
    const response = await ApiClient.post(
      '/admin/admin_users/' + id.toString(),
      body,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
        }
      }
    );
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const UpdateTrainsApi = async (
  id: number,
  body: object
): Promise<TrainsResponseType> => {
  try {
    const response = await ApiClient.post(
      '/admin/trains/' + id.toString(),
      body,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
        }
      }
    );
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const UpdateTrainGroupsApi = async (
  id: number,
  body: object
): Promise<TrainGroupsResponseType> => {
  try {
    const response = await ApiClient.post(
      '/admin/train_groups/' + id.toString(),
      body,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
        }
      }
    );
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const UpdateCategoriesApi = async (
  id: number,
  body: object
): Promise<CategoryResponseType> => {
  try {
    const response = await ApiClient.post(
      '/admin/categories/' + id.toString(),
      body,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
        }
      }
    );
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const UpdatePhrasesApi = async (
  id: number,
  body: object
): Promise<PhrasesResponseType> => {
  try {
    const response = await ApiClient.post(
      '/admin/phrases/' + id.toString(),
      body,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
        }
      }
    );
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const UpdateMailingListsApi = async (
  id: number,
  body: object
): Promise<MailingListResponseType> => {
  try {
    const response = await ApiClient.post(
      '/admin/mailinglists/' + id.toString(),
      body,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
        }
      }
    );
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const UpdateSettingsApi = async (
  id: number,
  body: object
): Promise<SettingsResponseType> => {
  try {
    const response = await ApiClient.post(
      '/admin/settings/' + id.toString(),
      body,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
        }
      }
    );
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};
